import { Badge } from "@package/subframe/components/Badge";

interface IncidentStatusBadgeProps {
  resolvedAt: string | null;
}

export function IncidentStatusBadge({ resolvedAt }: IncidentStatusBadgeProps) {
  return resolvedAt ? (
    <Badge variant="success">Resolved</Badge>
  ) : (
    <Badge variant="warning">Open</Badge>
  );
}
